var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false,"appear":""},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[_c('section',{class:this.name},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"content"})])])}
var staticRenderFns = []

export { render, staticRenderFns }